import { mode } from '@chakra-ui/theme-tools'
import { ChakraStyledOptions } from '@chakra-ui/react'

const Skeleton = {
  baseStyle: (props: ChakraStyledOptions) => ({
    startColor: mode('brandGray.300', 'brandGray.800')(props),
    endColor: mode('brandGray.400', 'brandGray.750')(props),
  }),
}

export default Skeleton
